import React, { memo } from 'react';
import { scrollToPurchase } from '../utils/checkout';
export function HeroSection() {
  return <section className="bg-gradient-to-b from-[#2A1D10] via-[#3B2A1A] to-[#4A3525] pt-4 md:pt-6 pb-8 md:pb-10 px-4" data-id="element-175">
      <div className="max-w-3xl mx-auto text-center" data-id="element-176">
        {/* Audience line */}
        <p className="font-sans font-medium text-amber-300/80 uppercase tracking-wider text-[13px] md:text-xs mb-3 md:mb-5" data-id="element-177">
          For dog owners who want beautiful photos without expensive gear
        </p>

        {/* Main Headline */}
        <h1 className="font-serif text-[1.8rem] md:text-5xl lg:text-[3.4rem] font-bold text-white mb-4 md:mb-6 leading-[1.08] md:leading-[1.1]" data-id="element-178">
          Take better dog photos.
          <br data-id="element-179" />
          <span className="italic text-soft-gold" data-id="element-180">With your phone.</span>
          <br data-id="element-181" />
          Starting today.
        </h1>

        {/* Hero Mockup Image — DO NOT CHANGE THIS URL */}
        <a href="#purchase" onClick={scrollToPurchase} className="block mb-4 md:mb-6 cursor-pointer group" data-id="element-182">
          <img src="https://cdn.magicpatterns.com/uploads/oMwr1o2GGfg6HJQmfMrzfj/ChatGPT_Image_Apr_11,_2026,_03_17_01_PM_-_Edited.png" alt="The Pawfect Shot MegaPack — 6 complete guides for stunning dog photography with your phone" className="w-full max-w-[330px] md:max-w-xl mx-auto rounded-lg shadow-2xl transition-transform duration-300 group-hover:scale-[1.02]" fetchPriority="high" width={576} height={576} data-id="element-183" />
        </a>

        {/* Subheadline */}
        <p className="font-sans text-[13.5px] md:text-lg text-amber-100/85 mb-4 md:mb-6 max-w-2xl mx-auto leading-[1.4] md:leading-relaxed" data-id="element-184">
          The complete digital system for dog owners who want beautiful
          portraits, better action shots, and more meaningful memories — without
          expensive gear or confusing photography jargon.
        </p>

        {/* Compact Badges */}
        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-2 mb-4 md:mb-6" data-id="element-185">
          {['📄 100% Digital', '⚡ Instant Access', '📱 Built for Phone Users', '🐾 Beginner-Friendly'].map(badge => <span key={badge} className="font-sans text-[11px] md:text-xs font-medium text-amber-100/90 border border-amber-300/30 rounded-full px-2.5 md:px-3 py-1 md:py-1.5 bg-amber-900/20" data-id="element-186">
              {badge}
            </span>)}
        </div>

        {/* CTA Button */}
        <button onClick={scrollToPurchase} className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-sans font-bold text-base md:text-lg py-4 px-10 rounded-full shadow-cta transition-all duration-300 transform hover:-translate-y-1 uppercase text-center" data-id="element-187">
          👉 YES, I WANT INSTANT ACCESS NOW
        </button>

        {/* Trust line */}
        <p className="font-sans text-[11px] md:text-sm text-amber-200/60 mt-2.5 md:mt-3 flex items-center justify-center gap-2 md:gap-3 flex-wrap" data-id="element-188">
          <span data-id="element-189">✅ 7-Day Satisfaction Guarantee</span>
          <span data-id="element-190">🔒 Secure Checkout</span>
          <span data-id="element-191">⚡ Instant Access</span>
        </p>
      </div>
    </section>;
}